import { XMLDatas } from 'src/interfaces/xmldata.interface';
import { INfsFile } from '../interfaces/nfsfile.interface';
import * as moment from 'moment';

export class NfsFileModel implements INfsFile {
  txt_file_data?: string;
  txt_file_name?: string;
  xml_data?: XMLDatas[];
  xml_model?: string;
  xml_data_errors?: any[];
  xml_data_sends?: any[];
  location_file_uid?: string;
  location?: string;
  sended?: boolean;
  dtupdate?: string;
  _id?: string;

  public static fromJson(js: INfsFile): NfsFileModel {
    let obj = new NfsFileModel();
    obj.txt_file_data = js.txt_file_data;
    obj.txt_file_name = js.txt_file_name;
    obj.xml_data = js.xml_data;
    obj.xml_model = js.xml_model;
    obj.xml_data_errors = js.xml_data_errors;
    obj.xml_data_sends = js.xml_data_sends;
    obj.location_file_uid = js.location_file_uid;
    obj.location = js.location;
    obj.sended = js.sended;
    obj.dtupdate = js.dtupdate;
    obj._id = js._id;
    return obj;
  }

  get data_Error() {
    try {
      const errors = this.xml_data_errors.map((e: string) => {
        if (e.includes('Erro ao analisar nota Mei =>')) {
          // Regex para capturar o erro interno
          const match = e.match(/'erro': '([^']+ -> [^']+)'/);
          if (match) {
            const erroExtraido = match[1];
            console.log(erroExtraido);
            return `Erro ao analisar nota Mei => ${erroExtraido}`;
          }
        }
        return e;
      });
      return errors.join('; ');
    } catch (error) {
      console.error('Error parsing xml_data_errors:', error);
      return this.xml_data_errors.join('; ');
    }
  }

  public static fromJsonArray(js_array: INfsFile[]): NfsFileModel[] {
    return js_array.map((j) => NfsFileModel.fromJson(j));
  }

  toJson() {
    return {
      txt_file_data: this.txt_file_data,
      txt_file_name: this.txt_file_name,
      xml_data: this.xml_data,
      xml_model: this.xml_model,
      xml_data_errors: this.xml_data_errors,
      xml_data_sends: this.xml_data_sends,
      location_file_uid: this.location_file_uid,
      location: this.location,
      sended: this.sended,
      dtupdate: this.dtupdate,
      _id: this._id,
    };
  }

  toExcelValues() {
    return {
      Arquivo: this.txt_file_name,
      Modelo: this.xml_model,
      Erros: this.data_Error,
      Localização: this.location.split('/').splice(2).join('/'),
      'Data de Upload': this.date,
    };
  }

  get errors_list() {
    return this.xml_data_errors.join('; ');
  }

  get date() {
    return moment(this.dtupdate, 'YY-MM-DD HH:mm:SS').format(
      'DD/MM/YYYY HH:mm:SS'
    );
  }
}

export const reportNfsFileModel = (items: NfsFileModel[]) => {
  return items.map((item) => {
    return {
      Arquivo: item.txt_file_name,
      Modelo: item.xml_model,
      Erros: item.errors_list,
    };
  });
};
